import { Box, Grid2, TextField } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import ImageDataRenderer from "components/ImageDataRenderer/ImageDataRenderer"
import { FormEvent } from "react"
import Camera from "./Camera"

type CaptureFotoProps = {
  handleSave: (arg: FormEvent<HTMLFormElement>) => void
  onCapture: (img: string) => void
  fotos: string[]
  setFotos: (fotos: string[]) => void
  imageName?: string
}

export const CaptureFoto = (props: CaptureFotoProps) => {
  const { handleSave, onCapture, fotos, setFotos, imageName } = props

  return (
    <Box
      component="form"
      onSubmit={handleSave}
      id="form"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      {fotos.length === 0 ? (
        <Camera label="Foto erfassen" onCapture={onCapture} />
      ) : (
        <Box
          sx={{
            width: "100%",
            maxWidth: 500,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <ImageDataRenderer imageDataArray={fotos} />
          <TextField
            label="Titel"
            name="title"
            defaultValue={imageName}
            fullWidth
            size="small"
            required
          />
          <TextField
            label="Beschreibung (Was zeigt das Bild?)"
            name="description"
            fullWidth
            size="small"
            multiline
            rows={2}
            placeholder="z.B. Vorderansicht des Geräts, Anschlüsse, Typenschild..."
          />
          <Grid2 container spacing={2}>
            <Grid2 size={6}>
              <StyledButton
                buttonType="cancel"
                fullWidth
                variant="contained"
                onClick={() => setFotos([])}
              />
            </Grid2>
            <Grid2 size={6}>
              <StyledButton
                buttonType="save"
                fullWidth
                variant="contained"
                form="form"
                type="submit"
                disabled={!fotos.length}
              />
            </Grid2>
          </Grid2>
        </Box>
      )}
    </Box>
  )
}
